import React from 'react';
import {
  StatCard,
  StatCardContent,
  StatIconCircle,
  StatCardTitleText,
  StatNumberText,
  StatSubnote,
} from '../MyStats.styles';

export interface StatCardProps {
  icon: React.ReactElement;
  iconBg?: string;
  iconColor?: string;
  title: string;
  value: string;
  subtext?: string;
}

const StatCardComponent: React.FC<StatCardProps> = ({ icon, iconBg, iconColor, title, value, subtext }) => (
  <StatCard>
    <StatCardContent>
      <StatIconCircle $bg={iconBg || '#EBF0F9'}>
        {React.cloneElement(icon, { style: { color: iconColor || '#0B4598', fontSize: '1.2rem' } })}
      </StatIconCircle>
      <StatCardTitleText variant="body2">{title}</StatCardTitleText>
      <StatNumberText>{value}</StatNumberText>
      {subtext && <StatSubnote variant="body2">{subtext}</StatSubnote>}
    </StatCardContent>
  </StatCard>
);

export default StatCardComponent;
